import type { RootState } from '../../../store';
import type { NormalizedItem as CachedItem } from '@/components/itemList/types';

// Re-export the canonical NormalizedItem so shake components keep compiling
export type NormalizedItem = CachedItem;

/**
 * Read items from the global itemsSlice cache using the current project ID.
 * Falls back to state.project.items for legacy / guest-project paths.
 */
export const selectAllProjectItems = (state: RootState): NormalizedItem[] => {
  const projectId = state.project.projectId as string | null;

  // Primary source: itemsSlice global cache
  if (projectId) {
    const cached = state.items.byParent[projectId];
    if (cached?.items) return cached.items;
  }

  return [];
};

// Filter helpers
export const selectImages = (state: RootState): NormalizedItem[] =>
  selectAllProjectItems(state).filter((it) => it.type === 'image');

export const selectAudios = (state: RootState): NormalizedItem[] =>
  selectAllProjectItems(state).filter((it) => it.type === 'audio');

export const selectVideos = (state: RootState): NormalizedItem[] =>
  selectAllProjectItems(state).filter((it) => it.type === 'video');

// Resolve one by id, returning normalized or null
export const selectItemById = (state: RootState, id: string): NormalizedItem | null =>
  selectAllProjectItems(state).find((it) => it.id === id) || null;

export const selectItemByNameAndType = (state: RootState, name: string, type: string): NormalizedItem | null =>
  selectAllProjectItems(state).find((it) => it.name === name && it.type === type) || null;
